const image = (data) => {
	const {
		media_details: {
			sizes: {
				// medium 163x, thumbnail 150x, full 720x
				medium: { file },
			},
		},
	} = data

	return {
		file,
	}
}

export default image
